<template>
    <div class="dashboard cust-drivers cust-drivers--worktime">
        <template v-if="dataWorkTime.driver_name">
            <h1>出社時間確認</h1>
            <div>
                <div>{{ dataWorkTime.driver_name }}さん</div>
                <div class="l-mt2 cust-drivers__work-times">
                    明日の出社時間
                    <span v-if="dataWorkTime.work_time_update == 1">{{ dataWorkTime.work_time }}</span>
                    <span v-else>変更なし</span>
                </div>
            </div>
            <div class="l-mt6">
                <!-- <button :class="`${classButtonStyle}primary`" type="button" @click="handleUpdate">更新</button> -->
                <router-link :to="{ name: 'drivers_daily_reports' }" :class="`${classButtonStyle}other`" type="button" tag="button">運転日報を見る</router-link>
            </div>
        </template>
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";

    export default {
        "mixins": [
            common,
        ],
        data() {
            return {
                "classButtonStyle": "button--oval--",
                "dataWorkTime": {},
                "params": {
                    "id": "0",
                    "date": "",
                },
                "updateCheck": "",
            };
        },
        created() {
            this.fetchingDataWorkTime();
        },
        mounted() {
            const date = new Date();
            date.setDate(date.getDate() + 1);
            this.params.date = `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${("0" + (date.getDate())).slice(-2)}`;
            this.updateCheck = setInterval(() => {
                this.handleUpdate();
            }, 5000);
        },
        beforeDestroy() {
            clearInterval(this.updateCheck);
        },
        "methods": {
            fetchingDataWorkTime() {
                // 個別ドライバー出社時間データ取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/work_times`,
                    this.$_requestConfig("params")
                ).then(response => {
                    this.dataWorkTime = response.data;
                }).catch(() => {
                    console.log("出社時間の取得に失敗しました。");
                    // this.$router.push({ "name": "drivers_logout" });
                });
            },
            handleUpdate() {
                // 納入先データ（ドライバー用）取得
                common.$_axios.get(
                    `${common.$_configs.apiUrl}/delivery_destinations/driver`,
                    this.$_requestConfig()
                ).then(() => {
                    setTimeout(() => {
                        this.$router.push({ "name": "drivers_delivery_destinations" });
                    }, 1000);
                });
                this.fetchingDataWorkTime();
            },
        },
    };
</script>
